<template>
  <div id="inputData">
    <h4>{{$t('message.metoda_kontroli')}}</h4>

      <div class="form-group">
        <input type="checkbox" class="form-control form-control-sm" id="sygnal_pilota_cb"
        v-model="inputData.sygnal_pilota_cb.value"
        @change="changeInputs('sygnal_pilota_cb')">
        <label for="sygnal_pilota" style="width: 218px;  line-height: 26px;  margin-left: 5px;">{{$t('message.sygnal_pilota')}}</label>
        <input
         v-if="inputData.sygnal_pilota_cb.value"
         type="number" value="0" class="form-control form-control-sm" id="sygnal_pilota" step='10'
         :min="inputs.sygnal_pilota.min"
         :max="inputs.sygnal_pilota.max"
         v-model="inputData.sygnal_pilota.value"
        @change="changeInputs('sygnal_pilota')">
      </div>

      <div class="form-group">
        <label for="moc_glosnikow">{{$t('message.moc_glosnikow')}}</label>
        <input
         type="number" class="form-control form-control-sm" id="moc_glosnikow" step='10'
         :min="inputs.moc_glosnikow.min"
         :max="inputs.moc_glosnikow.max"
         v-model="inputData.moc_glosnikow.value"
        @change="changeInputs('moc_glosnikow')">
      </div>

      <div class="form-group">
        <label for="moc_systemu">{{$t('message.moc_systemu')}}</label>
        <input
        type="number" class="form-control form-control-sm" id="moc_systemu"
        v-model="inputData.moc_systemu.value"
        @change="changeInputs('moc_systemu')">
      </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { app } from '../mixins/app'
import { materials } from '../mixins/materials'
import { calculation } from '../mixins/calculation'

export default {
  name: 'inputData',
  mixins: [app, materials, calculation],
  data () {
    return {
      inputData: {
        sygnal_pilota_cb: { 'value': false },
        sygnal_pilota: { 'value': 0, 'min': 0, 'max': 9000 },
        moc_glosnikow: { 'value': 0, 'min': 0, 'max': 9000 },
        moc_systemu: { 'value': 0 }
      }
    }
  },
  computed: {
    ...mapGetters('app', ['config']),
    ...mapGetters('app', ['inputs']),
    ...mapGetters('app', ['outputs']),
    ...mapGetters('products', ['ListaSzafy']),
    ...mapGetters('products', ['ListaAkcesoria']),
    ...mapGetters('products', ['ListaAkumulatory']),
    ...mapGetters('products', ['ListaZasilacze']),
    ...mapGetters('products', ['ListaListwyD']),
    ...mapGetters('products', ['ListaListwyZ']),
    ...mapGetters('products', ['ListaMaterialy'])
  },
  watch: {
    inputs: {
      deep: true, // <!-- This is important;
      handler (newValue) {
        Object.keys(this.inputData).forEach(element => {
          this.inputData[element]['value'] = newValue[element].value
        })
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/MetodaKontroli.vue